import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input } from "../../../../../global-account/react/index.js";
import { useState } from "react";
export function PasswordInput(t0) {
  const $ = _c(11);
  const {
    value,
    onChange,
    disabled,
    placeholder: t1,
    onKeyDown,
    className
  } = t0;
  const placeholder = t1 === undefined ? "Password" : t1;
  const [showPassword, setShowPassword] = useState(false);
  const t2 = showPassword ? "text" : "password";
  let t3;
  if ($[0] !== className || $[1] !== disabled || $[2] !== onChange || $[3] !== onKeyDown || $[4] !== placeholder || $[5] !== showPassword || $[6] !== t2 || $[7] !== value) {
    let t4;
    if ($[9] !== showPassword) {
      t4 = () => setShowPassword(!showPassword);
      $[9] = showPassword;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = _jsxs("div", {
      className: "relative",
      children: [_jsx(Input, {
        type: t2,
        placeholder,
        value,
        onChange,
        disabled,
        onKeyDown,
        className
      }), _jsx("button", {
        type: "button",
        onClick: t4,
        "aria-label": showPassword ? "Hide password" : "Show password",
        className: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300",
        tabIndex: -1,
        children: showPassword ? _jsx("svg", {
          className: "h-5 w-5",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: 1.5,
          children: _jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
          })
        }) : _jsxs("svg", {
          className: "h-5 w-5",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: 1.5,
          children: [_jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
          }), _jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          })]
        })
      })]
    });
    $[0] = className;
    $[1] = disabled;
    $[2] = onChange;
    $[3] = onKeyDown;
    $[4] = placeholder;
    $[5] = showPassword;
    $[6] = t2;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}